
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"isolation":"isolate"},style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","style":"isolation:isolate","viewBox":"0 0 24 24","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z"}})])]),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M18.701 12.81c-3.046 2.84-7.835 2.673-10.675-.373-2.841-3.046-2.674-7.834.372-10.675C9.27.949 10.283.433 11.376 0c-1.14 1.497-2.911 5.526.332 9.003 3.2 3.431 7.106 2.159 8.958.959-.327 1.034-1.094 2.035-1.965 2.848zM6.6 23.888l-.747-2.108h-2.99l-.747 2.108H1l2.8-7.809h1.116l2.8 7.809H6.6zM3.198 20.82h2.32l-1.16-3.257-1.16 3.257zm8.624-2.398h1.004v5.466h-.893l-.111-.602q-.268.368-.631.541-.362.173-.887.173-.981 0-1.5-.597t-.519-1.802v-3.179h1.004v2.901q0 .892.307 1.338.307.447.965.447.39 0 .731-.157.34-.156.53-.457v-4.072zM16.072 24q-.725 0-1.077-.379-.351-.38-.351-.926v-3.492h-.937l.089-.781h.848v-1.35l1.004-.1v1.45h1.439v.781h-1.439v2.878q0 .569.067.781.067.212.284.273.218.062.798.062h.257l-.078.803h-.904zm4.217 0q-.837 0-1.45-.374-.614-.373-.937-1.021-.324-.647-.324-1.45 0-.803.324-1.45.323-.647.937-1.021.613-.374 1.45-.374.826 0 1.445.374.619.374.942 1.021.324.647.324 1.45 0 .803-.324 1.45-.323.648-.942 1.021-.619.374-1.445.374zm0-.892q.803 0 1.244-.514.441-.513.441-1.439t-.441-1.439q-.441-.513-1.244-.513-.803 0-1.244.513-.441.513-.441 1.439t.441 1.439q.441.514 1.244.514z"}})])])
          )
        }
      }
    